import { TemplateTypes } from "Enums";

/**
 * Used to pass settings to Grids, which can be overridden on use.
 */
export class GridSettings {

    private _dataUrlGet: string;
    private _dataUrlSet: string;
    private _templates: Object = {};

    /**
    * The Url which is used for getting data for the Grid.
    */
    public get dataUrlGet(): string {
        return this._dataUrlGet;
    }

    public set dataUrlGet(_dataUrlGet: string) {
        this._dataUrlGet = _dataUrlGet;
    }

    /**
    * The Url which is used for saving data back to the service.
    */
    public get dataUrlSet(): string {
        return this._dataUrlSet;
    }
    public set dataUrlSet(_dataUrlSet: string) {
        this._dataUrlSet = _dataUrlSet;
    }

    private _customSettings: Object = {};

    public get customSettings(): Object {
        return this._customSettings;
    }

    /**
     * Gets the template for defined templatetype.
     * @param templateType Type of template.
     */
    public getTemplate(templateType: TemplateTypes): string {
        return this._templates[templateType] as string;
    }

    /**
     * Sets the template for defined templatetype.
     * @param templateType Type of template.
     * @param template html-string.
     */
    public setTemplate(templateType: TemplateTypes, template: string) {
        this._templates[templateType] = template;
    }
}